require('../../../corporate-template/js/feature/language-selector-spot.js');